import React from 'react';
export function OfferSection() {
  return <section className="bg-navy-800 py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-97">
      {/* Background accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-98"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-99">
        <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-100">
          Recupera el mando de tu biología hoy mismo.
        </h2>
        <p className="text-xl text-[#e0e0e0] mb-12" data-id="element-101">
          Evita años de declive y cansancio por menos de lo que cuesta una cena
          fuera de casa.
        </p>

        <div className="bg-navy-900 rounded-3xl p-8 sm:p-12 border border-gold-500/30 shadow-2xl" data-id="element-102">
          <div className="mb-4" data-id="element-103">
            <span className="text-gray-400 line-through text-2xl mr-4" data-id="element-104">
              $97 USD
            </span>
            <span className="text-5xl sm:text-6xl font-bold text-gold-500" data-id="element-105">
              $27 USD
            </span>
          </div>
          <p className="text-white font-medium mb-8" data-id="element-106">
            Obtén el Protocolo 40 Rendimiento Alpha completo
          </p>

          <a href="https://vitalizateahora.com/cart/51925549973735:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-lg sm:text-xl py-5 px-10 rounded-full transition-all duration-300 shadow-[0_4px_20px_0_rgba(201,168,76,0.4)] hover:shadow-[0_8px_30px_rgba(201,168,76,0.3)] hover:-translate-y-1 mb-4 text-center" data-id="element-107">
            DESCARGAR EL PROTOCOLO ALPHA AHORA
          </a>

          <p className="text-sm text-gray-400 flex items-center justify-center gap-2" data-id="element-108">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-109">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-110" />
            </svg>
            Acceso instantáneo. Pago seguro y discreto.
          </p>
        </div>
      </div>
    </section>;
}